import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type PumpingResumedPayload = {
  insulin_amount?: number;
};

export type PumpingResumedEvent = {
  insulinAmount?: number;
};

const pumpingResumedSchema = z.object({
  insulin_amount: cz.permissive(z.number()),
});

export const LID_PUMPING_RESUMED = {
  value: 0x0c,
  name: "Pumping Resumed Event",
  format: "....h..........",
  fields: ["insulin_amount"],
  postprocess: rec => ({
    insulinAmount: rec.insulin_amount,
  }),
  schema: pumpingResumedSchema,
} as const satisfies TandemEventDefinition<PumpingResumedPayload, PumpingResumedEvent>;
